import { getStorage } from "store/local";
import { isHexColor } from "./colors";
import { fetchCounts } from "./counts";
import { fetchSiteData, isFilled, resolveHotelData } from "./hotelDefaults";
import { SETUP_COUNTS, SETUP_FIELDS, SETUP_QR_PRINTED_KEY } from "../constants";

function getSetupChecks({ melhous, defaults }, counts) {
  const data = resolveHotelData(melhous, defaults);
  return {
    hotel: isFilled(data.title) && isFilled(data.phone),
    colors: isHexColor(data.primary_color),
    link: isFilled(melhous?.link_melhous),
    care: counts.request_types > 0 && (counts.messages > 0 || counts.guide > 0),
  };
}

async function fetchSetupChecks() {
  const [site, counts] = await Promise.all([
    fetchSiteData(SETUP_FIELDS),
    fetchCounts(SETUP_COUNTS),
  ]);
  return getSetupChecks(site, counts);
}

function getQrPrintedKey() {
  const { db } = getStorage("ctxSession") || {};
  return `${SETUP_QR_PRINTED_KEY}.${db}`;
}

function readQrPrinted() {
  try {
    return localStorage.getItem(getQrPrintedKey()) === "1";
  } catch {
    return false;
  }
}

function writeQrPrinted(printed) {
  try {
    if (printed) localStorage.setItem(getQrPrintedKey(), "1");
    else localStorage.removeItem(getQrPrintedKey());
    return true;
  } catch {
    return false;
  }
}

export { fetchSetupChecks, readQrPrinted, writeQrPrinted };
